import { AccountVerification as AccountVerificationFeature } from '../../../features/verification/components/account-verification';

const AccountVerification = () => <AccountVerificationFeature />;

export { AccountVerification };
